<template>
    <el-menu class="navbar" mode="horizontal">
        <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <Breadcrumb></Breadcrumb>
        <!--     <goback class="goback"
            v-show="showBack"></goback> -->
        <div class="headRight">
            <!-- <screenfull class="avatar-container hidden-sm-and-down"></screenfull> -->
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <!-- <el-avatar shape="square" size="medium" :src="avatar"></el-avatar>
          <i class="el-icon-caret-bottom" /> -->
                    <div>{{userinfo.roleName}}：{{userinfo.fullName}}</div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <router-link :to="{name: 'Manage'}">
                        <el-dropdown-item>修改密码</el-dropdown-item>
                    </router-link>
                    <!-- <el-dropdown-item v-if='showStore'>
                        <router-link :to="editStore">
                            修改门店
                        </router-link>
                    </el-dropdown-item> -->
                    <el-dropdown-item divided @click.native="logout">
                        <span style="display:block;">退出</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </el-menu>
</template>
<script>
import { mapGetters } from 'vuex';
import Hamburger from '@/components/Hamburger';
import Breadcrumb from '@/components/Breadcrumb';
import goback from '@/components/goback';
import screenfull from '@/components/screenfull';
import { openBox } from '@/utils/message';
import { getcurStoreId } from '@/utils/auth';

export default {
    components: {
        Hamburger,
        screenfull,
        Breadcrumb,
        goback
    },
    computed: {
        ...mapGetters(['sidebar', 'userinfo'])
    },
    mounted(){
      var storeId=getcurStoreId();
      this.showStore=!!storeId;
      if(this.showStore){
        this.editStore.name='StoreEdit';
        this.editStore.query={ id: storeId };
      }
    },
    data() {
        return {
          showStore:false,
          editStore:{
            name:'',
            query:{}
          }
        };
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('ToggleSideBar');
        },
        logout() {
            openBox('确定退出系统吗？', { type: 'warning' }, () => {
                this.$store.dispatch('FedLogOut').then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            });
        }
    }
};

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/variables.scss';

.navbar {
    background-color: $navBg;
    height: 50px;
    /*width: 100%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1001;*/
    overflow: hidden;
    position: relative;
    line-height: 50px;
    border-radius: 0px !important;

    i {
        font-size: 20px;
    }

    .hamburger-container {
        height: 50px;
        line-height: 50px;
        float: left;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 10px;
        cursor: pointer;
        color: $navText;
    }

    .goback {
        height: 50px;
        line-height: 50px;
        float: left;
    }

    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: $navText;
    }

    .headRight {
        position: absolute;
        top: 0;
        right: 35px;
        display: flex;
        justify-content: space-between;
    }

    .avatar-container {
        &:not(:last-child) {
            padding-right: 10px;
        }

        height: 50px;
        display: inline-block;
        color: $navText;

        .avatar-wrapper {
            cursor: pointer;
            margin-top: 5px;
            position: relative;

            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }

            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue